(() => {
  const bindDrawerClose = () => {
    document.querySelectorAll('[data-immershop-drawer-close]').forEach((button) => {
      if (button.dataset.immershopDrawerBound === 'true') return;
      button.dataset.immershopDrawerBound = 'true';
      button.addEventListener('click', (event) => {
        const drawer = button.closest('header-drawer');
        const summary = drawer?.querySelector('details > summary');
        if (!drawer || !summary) return;
        event.preventDefault();
        drawer.closeMenuDrawer?.(event, summary);
      });
    });
  };
  document.addEventListener('DOMContentLoaded', bindDrawerClose, { once: true });
  bindDrawerClose();
})();
